import { useEffect } from "react";

// 새로고침 경고 훅
export const useReloadWarning = () => {
  const reloadPage = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  return useEffect(() => {
    window.addEventListener("beforeunload", reloadPage);
    return () => {
      window.removeEventListener("beforeunload", reloadPage);
    };
  }, []);
};
